import { render, staticRenderFns } from "./consume_count.vue?vue&type=template&id=99a112fc&"
import script from "./consume_count.vue?vue&type=script&lang=js&"
export * from "./consume_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports